import { render, staticRenderFns } from "./MFilters.vue?vue&type=template&id=5f703c64"
import script from "./MFilters.vue?vue&type=script&lang=js"
export * from "./MFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports